import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/authSlice';
import uiModalReducer from '@/features/ui/uiModalSlice';
import viewedUserInfoReducer from '@/features/user/viewedUserInfoSlice';
import viewedStoreInfoReducer from '@/features/store/viewedStoreInfoSlice';
import uiLoadingReducer from '@/features/ui/uiLoadingSlice';

export const makeStore = () =>
  configureStore({
    reducer: {
      auth: authReducer,
      uiModal: uiModalReducer,
      viewedUserInfo: viewedUserInfoReducer,
      viewedStoreInfo: viewedStoreInfoReducer,
      uiLoading: uiLoadingReducer,
    },
    middleware: (getDefault) =>
      getDefault({
        serializableCheck: false, // 你有 FormData 等非序列化 payload 時會更安靜
      }),
    devTools: process.env.NODE_ENV !== 'production',
  });

export const store = makeStore();

// 型別工具
export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
